import axios from "axios";
import { SET_ALERT } from "../alert"
import router from "../../router"
import contracts from "./contracts"

export const SET_CONTRACT = 'SET_CONTRACT';
export const SET_LOADING = 'SET_LOADING';

export default {
    state: {
        contract: null,
        isLoading: false,
    },
    mutations: {
        [SET_LOADING](state, loading) {
            state.isLoading = loading;
        },
        [SET_CONTRACT](state, contract) {
            state.contract = contract;
        },
    },
    actions: {
        getContract({ commit }, id) {
            axios
                .get("contracts/" + id, {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
                    }
                })
                .then((response) => {
                    commit(SET_CONTRACT, response.data)
                })
                .catch((error) => {
                    if (error.response.data) {
                        commit(SET_ALERT, {
                            message: error.response.data.message,
                            type: 'error'
                        });
                    }
                });
        },

        createContract({ commit }, form) {
            commit(SET_LOADING, true);
            axios
                .post("contracts", form,
                    {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
                        }
                    })
                .then((response) => {
                    commit(SET_LOADING, false);
                    commit(SET_ALERT, {
                        message: "Contrato creado correctamente",
                        type: 'success'
                    });
                    window.open(response.data.contract_url, "_blank");
                    router.push({ path: "/contracts" });
                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    if (error.response.data) {
                        var message;
                        error.response.data.errors ?
                            message = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0] :
                            message = error.response.data.message;

                        commit(SET_ALERT, {
                            message: message,
                            type: 'error'
                        })
                    }
                });
        },

        updateContract({ commit, dispatch }, payload) {
            commit(SET_LOADING, true);
            axios
                .post("contracts/" + payload.id, payload.form,
                    {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
                        }
                    })
                .then(() => {
                    commit(SET_LOADING, false);
                    commit(SET_ALERT, {
                        message: "Contrato editado correctamente",
                        type: 'success'
                    });
                    dispatch('getContracts');
                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    if (error.response.data) {
                        commit(SET_ALERT, {
                            message: error.response.data.message,
                            type: 'error'
                        })
                    }
                });
        },

        deleteContract({ commit, dispatch }, id) {
            commit(SET_LOADING, true);
            axios
                .delete("contracts/" + id,
                    {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
                        }
                    })
                .then(() => {
                    commit(SET_LOADING, false);
                    commit(SET_ALERT, {
                        message: "Contrato eliminado correctamente",
                        type: 'success'
                    });
                    dispatch('getContracts');
                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    if (error.response.data) {
                        commit(SET_ALERT, {
                            message: error.response.data.message,
                            type: 'error'
                        })
                    }
                });
        },

        createContractPdf({ commit, dispatch }, form) {
            commit(SET_LOADING, true);
            axios
                .post("contrats_pdf", form,
                    {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
                        }
                    })
                .then(() => {
                    commit(SET_LOADING, false);
                    commit(SET_ALERT, {
                        message: "Contrato PDF creado correctamente",
                        type: 'success'
                    });
                    dispatch("getContract", router.currentRoute.params.id);
                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    if (error.response.data) {
                        var message;
                        error.response.data.errors ?
                            message = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0] :
                            message = error.response.data.message;

                        commit(SET_ALERT, {
                            message: message,
                            type: 'error'
                        })
                    }
                });
        },

        createCertificate({ commit, dispatch }, form) {
            commit(SET_LOADING, true);
            axios
                .post("certificates", form,
                    {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
                        }
                    })
                .then(() => {
                    commit(SET_LOADING, false);
                    commit(SET_ALERT, {
                        message: "Certificado generado correctamente",
                        type: 'success'
                    });
                    dispatch("getContract", router.currentRoute.params.id);
                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    if (error.response.data) {
                        var message;
                        error.response.data.errors ?
                            message = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0] :
                            message = error.response.data.message;

                        commit(SET_ALERT, {
                            message: message,
                            type: 'error'
                        })
                    }
                });
        },
    },
    modules: {
        contracts
    }
};
